// components/Loader.tsx
import { FC } from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100%;
`;

const Spinner = styled.div<{size?: number}>`
  width: ${({ size }) => size || 40}px;
  height: ${({ size }) => size || 40}px;
  border: 4px solid #e0e0e0;
  border-top-color: #3498db;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const Loader:FC<{size?: number}> = ({ size }) => (
  <LoaderWrapper>
    <Spinner size={size}/>
  </LoaderWrapper>
);

